<template>
    <div class="h-full w-[90%] lg:w-1/2 flex justify-center items-center">
        <div class="h-fit max-h-[98%] lg:h-fit w-full bg-white rounded-3xl relative overflow-y-auto my-5 shadow-xl">

            <div :class="[
                'text-white w-full py-5 text-lg bg-gradient-to-br from-gifty-pink to-gifty-pink_dark rounded-t-3xl flex justify-center items-center text-center font-extrabold ',
                locale === 'ar' ? 'font-arabic' : ''
            ]">
                {{ $t('register.registration_form') }}
            </div>

            <div class="w-full h-[92.625%] lg:h-[87.5%] overflow-auto p-5 flex flex-col space-y-3">
                <!-- Personal Info -->
                <div class="py-5 border-b border-gray-300">
                    <div class="text-lg font-semibold text-gifty-text_blue mb-5"
                        :class="locale == 'ar' ? ' font-arabic ' : ' '">
                        {{ $t('register.personal_info') }}
                    </div>

                    <div class="w-full mt-2 grid grid-cols-1 gap-4">
                        <!-- Phone Number -->
                        <div>
                            <label class="text-sm text-slate-600 mb-2 block"
                                :class="locale === 'ar' ? 'font-arabic' : ''">
                                {{ $t('register.phone_number') }}
                            </label>
                            <input v-model="form.phone_number" :disabled="registerStore.user_exists" :class="'w-full rounded-lg border-2 border-slate-200 bg-slate-50 text-sm placeholder-gray-500 outline-none focus:border-gifty-pink focus:border-2 transition duration-300 px-3 py-3 '
                                + (locale == 'ar' ? ' text-lg font-arabic ' : ' ')
                                + (inputErrors.phone_number ? 'border-red-500' : 'border-gray-300')
                                + (registerStore.user_exists ? ' bg-gray-100 text-gray-400 font-semibold' : ' ')
                                " type="tel" placeholder="Ex: 0770770000" @input="handlePhoneInput" />
                            <p v-if="inputErrors.phone_number" class="text-sm text-red-500 mt-1">
                                {{ $t(inputErrors.phone_number) }}
                            </p>
                        </div>

                        <!-- Full Name -->
                        <div>
                            <label class="text-sm text-slate-600 mb-2 block"
                                :class="locale === 'ar' ? 'font-arabic' : ''">
                                {{ $t('register.full_name') }}
                            </label>
                            <input v-model="form.fullname"
                                :disabled="registerStore.user_exists && registerStore.registration?.fullname != null"
                                :class="'w-full rounded-lg border-2 border-slate-200 bg-slate-50 text-sm placeholder-gray-500 outline-none focus:border-gifty-pink focus:border-2 transition duration-300 px-3 py-3 '
                                    + (locale == 'ar' ? ' text-lg font-arabic ' : ' ')
                                    + (inputErrors.fullname ? 'border-red-500' : 'border-gray-300')
                                    + (registerStore.user_exists && registerStore.registration?.fullname != null ? ' bg-gray-100 text-gray-400 font-semibold' : ' ')
                                    " type="text" :placeholder="$t('register.placeholders.full_name')" />
                            <p v-if="inputErrors.fullname" class="text-sm text-red-500 mt-1">
                                {{ $t(inputErrors.fullname) }}
                            </p>
                        </div>

                        <!-- Type -->
                        <div>
                            <label class="text-sm text-slate-600 mb-2 block"
                                :class="locale === 'ar' ? 'font-arabic' : ''">
                                {{ $t('register.type') }}
                            </label>
                            <select v-model="form.type"
                                :class="'w-full rounded-lg border-2 border-slate-200 bg-slate-50 text-sm placeholder-gray-500 outline-none focus:border-gifty-pink focus:border-2 transition duration-300 px-3 py-3 ' + (locale === 'ar' ? ' font-arabic text-lg ' : ' ') + (inputErrors.type ? 'border-red-500' : 'border-gray-300')">
                                <option v-for="type in types" :key="type.id" :value="type" class="font-arabic">
                                    {{ type.code }} - {{ locale === "ar" ? type.name_ar : type.name }}
                                </option>
                            </select>
                            <p v-if="inputErrors.type" class="text-sm text-red-500 mt-1"
                                :class="locale === 'ar' ? 'font-arabic' : ''">
                                {{ $t(inputErrors.type) }}
                            </p>
                        </div>

                        <!-- Wilaya & Commune -->
                        <div class="grid grid-cols-2 gap-4">
                            <div>
                                <label class="text-sm text-slate-600 mb-2 block"
                                    :class="locale === 'ar' ? 'font-arabic' : ''">
                                    {{ $t('register.wilaya') }}
                                </label>
                                <select v-model="form.wilaya"
                                    :disabled="registerStore.user_exists && registerStore.registration?.wilaya != null"
                                    :class="'w-full rounded-lg border-2 border-slate-200 bg-slate-50 text-sm placeholder-gray-500 outline-none focus:border-gifty-pink focus:border-2 transition duration-300 px-3 py-3 '
                                        + (locale === 'ar' ? ' font-arabic text-lg ' : ' ')
                                        + (inputErrors.wilaya ? 'border-red-500' : 'border-gray-300')
                                        + (registerStore.user_exists && registerStore.registration?.wilaya != null ? ' bg-gray-100 text-gray-400 font-semibold' : ' bg-white ')
                                        ">
                                    <option v-for="wilaya in wilayas" :key="wilaya.id" :value="wilaya"
                                        class="font-arabic">
                                        {{ wilaya.code }} - {{ locale === "ar" ? wilaya.name_ar : wilaya.name }}
                                    </option>
                                </select>
                                <p v-if="inputErrors.wilaya" class="text-sm text-red-500 mt-1">
                                    {{ $t(inputErrors.wilaya) }}
                                </p>
                            </div>

                            <div>
                                <label class="text-sm text-slate-600 mb-2 block"
                                    :class="locale === 'ar' ? 'font-arabic' : ''">
                                    {{ $t('register.commune') }}
                                </label>
                                <select v-model="form.commune"
                                    :disabled="registerStore.user_exists && registerStore.registration?.commune != null"
                                    :class="'w-full rounded-lg border-2 border-slate-200 bg-slate-50 text-sm placeholder-gray-500 outline-none focus:border-gifty-pink focus:border-2 transition duration-300 px-3 py-3 '
                                        + (locale === 'ar' ? ' font-arabic text-lg ' : '')
                                        + (inputErrors.commune ? 'border-red-500' : 'border-gray-300')
                                        + (registerStore.user_exists && registerStore.registration?.commune != null ? ' bg-gray-100 text-gray-400 font-semibold ' : ' bg-white ')
                                        ">
                                    <option v-for="commune in communes" :key="commune.id" :value="commune">
                                        {{ commune.code }} - {{ locale === "ar" ? commune.name_ar : commune.name }}
                                    </option>
                                </select>
                                <p v-if="inputErrors.commune" class="text-sm text-red-500 mt-1">
                                    {{ $t(inputErrors.commune) }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Submit Button -->
                <div>
                    <div @click="submitRegistration"
                        class="text-white w-fit bg-gradient-to-br from-gifty-pink to-gifty-pink_dark rounded-lg font-bold px-3 py-2 text-center mx-auto text-sm cursor-pointer"
                        :class="locale == 'ar' ? ' font-arabic ' : ''">
                        {{ $t('register.confirm_registration') }}
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script setup>
/* global fbq */

import { useI18n } from 'vue-i18n'
const { locale } = useI18n()
import { wilayas } from '@/data/wilayas';
import { dairas } from '@/data/dairas';
import { types } from '@/data/salespoint_types';
import { communes as dataCommunes } from '@/data/communes';
import { computed, ref, defineEmits, watch, onMounted, nextTick } from 'vue';
import { useRegistrationStore } from '@/stores/registrationStore';
import { useRouter } from 'vue-router';

const router = useRouter()
const registerStore = useRegistrationStore();
const emit = defineEmits(['toggleLoading', 'toggleMessageModal']);

const form = ref({
    phone_number: '',
    fullname: '',
    type: types[1],
    wilaya: wilayas[15],
    commune: null,
});

const handlePhoneInput = (e) => {
    form.value.phone_number = e.target.value.replace(/\D/g, '')
}

onMounted(() => {
    if (registerStore.user_exists) {
        form.value.phone_number = registerStore.registration.phone_number;
        form.value.fullname = registerStore.registration.fullname;
        form.value.type = types.find(f => f.id == registerStore.registration.type?.id || f.id == 3);

        let store_wilaya_id = registerStore.registration.wilaya || 16;
        let store_commune_id = registerStore.registration.commune || 511;

        setWilayaCommuneByIds(store_wilaya_id, store_commune_id);
    }
})

const inputErrors = ref({});

const communes = computed(() => {
    let selectedDairas = dairas.filter(d => d.wilaya_id === form.value.wilaya.id)
    return dataCommunes.filter(dc =>
        selectedDairas.some(d => d.id === dc.daira_id)
    );
});

watch(() => form.value.wilaya,
    () => {
        const relatedCommunes = communes.value;
        form.value.commune = relatedCommunes.length > 0 ? relatedCommunes[0] : null;
    },
    { immediate: true }
);

const validationRules = {
    phone_number: (v) => {
        if (!v) return 'register.errors.phone';
        if (!/^0[567]\d{8}$/.test(v)) return 'register.errors.phone';
        return null;
    },
    fullname: (v) => {
        if (!v) return 'register.errors.fullname_required'
        if (v.length < 5 || v.length > 191) return 'register.errors.fullname_invalid';
        return null;
    },
    type: (v) => (v ? null : 'register.errors.type_required'),
    wilaya: (v) => (v ? null : 'register.errors.wilaya_required'),
    commune: (v) => (v ? null : 'register.errors.commune_required'),
};

const validateFields = () => {
    let hasError = false;
    const errors = {};
    const skipFieldsIfUserExists = ['phone_number', 'fullname', 'wilaya', 'commune'];

    for (const field in validationRules) {
        if (registerStore.user_exists && skipFieldsIfUserExists.includes(field) && registerStore.registration[field] != null) {
            continue;
        }

        const rule = validationRules[field];
        const error = rule(form.value[field]);
        if (error) {
            hasError = true;
            errors[field] = error;
        }
    }

    inputErrors.value = errors;
    return !hasError;
};

const submitRegistration = async () => {
    const isValid = validateFields();
    if (!isValid) return;

    emit('toggleLoading', true);

    try {
        const payload = {
            phone_number: form.value.phone_number,
            full_name: form.value.fullname,
            type_id: form.value.type.id,
            wilaya: form.value.wilaya.id,
            commune: form.value.commune.id,
        };

        const registration_response = await registerStore.newRegisterPos(payload);

        showMessage(registration_response.success, registration_response.message);

        if (!registration_response.success) {
            console.warn('Registration failed:', registration_response.message);
        } else {
            registerStore.step = 2;

            setTimeout(() => {
                if (typeof fbq !== 'undefined') {

                    try {
                        console.log('fbq :>> ', fbq);
                        fbq('track', 'PageView', {
                            phone_number: payload.phone_number,
                            name: payload.full_name || '',
                        });

                        console.log('sent event fbq :>> ');

                    } catch (error) {
                        console.error('Error sending fbq event:', error);
                    }

                }


                router.push("successRegistration");

            }, 2000);
        }

    } catch (error) {
        console.error('Unexpected error during registration:', error);
        showMessage(false, "server_connection_error");
    } finally {
        emit('toggleLoading', false);
    }
};

const setWilayaCommuneByIds = (wilaya_id, commune_id) => {
    const wilaya = wilayas.find(w => w.id === wilaya_id);
    registerStore.registration.wilaya = wilaya;
    form.value.wilaya = wilaya || null;

    nextTick(() => {
        const commune = communes.value.find(c => c.id === commune_id);
        if (commune) {
            form.value.commune = commune;
            registerStore.registration.commune = commune;
        }
    });
};

const showMessage = (success, message) => {
    emit('toggleMessageModal', true, success, message, "registration");
}

watch(
    form,
    (newForm) => {
        for (const field in validationRules) {
            const rule = validationRules[field];
            const error = rule(newForm[field]);
            if (!error) {
                delete inputErrors.value[field];
            }
        }
    },
    { deep: true }
);
</script>